export default class CommonVariables {
}
CommonVariables.VIEW_CODE = 'viewCode';
CommonVariables.METHOD_OPTION = 'methodOption';
